import { GetProtegesQuery, useGetProtegesQuery } from './__generated__/getProteges.generated';

export const useProtegesList = () => {
	const { data, loading, error, refetch } = useGetProtegesQuery();

	const proteges = data?.currentUser.proteges || [];
	const superPalOf = data?.currentUser.superPalOf || [];
	const createdCareReceiverAccounts = superPalOf.length;
	const temporaryProteges = data?.currentUser.temporaryCaregiverOf || [];
	const careRecipients = data?.currentUser.caregiverOf || [];

	return {
		proteges,
		superPalOf,
		createdCareReceiverAccounts,
		temporaryProteges,
		careRecipients,
		loading,
		error,
		refetch,
	};
};

export type Friend = GetProtegesQuery['currentUser']['proteges'][number];
